import { render, staticRenderFns } from "./ProtocolItem.vue?vue&type=template&id=1b72c574&scoped=true&"
import script from "./ProtocolItem.vue?vue&type=script&lang=js&"
export * from "./ProtocolItem.vue?vue&type=script&lang=js&"
import style0 from "./ProtocolItem.vue?vue&type=style&index=0&id=1b72c574&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b72c574",
  null
  
)

export default component.exports